import {Alert, Backdrop, CircularProgress, Container, Grid, Paper, styled} from "@mui/material";
import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {getAllBatches} from "../features/allBatchesSlice";
import ExternalSourceBreadcrumbs from "../ExternalSourceManagement/ExternalSourceBreadcrumbs";
import Typography from "@mui/material/Typography";
import {batchCurrentStatus} from "../ExternalSourceManagement/ExternalSourceManagementHome";
import ExternalSourceBatchProgressBar from "../ExternalSourceManagement/ExternalSourceBatchProgressBar";
import ShowSnackbar from "../utils/ShowSnackbar";
import SuffixPagePasteURLPanel from "./SuffixPagePasteURLPanel";

/**
 * @date: 2022-08-11
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */


const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),

}))
const StyledPaper = styled(Paper)(({theme}) => ({
    padding: theme.spacing(2),
    overflow: 'auto',
    boxShadow: '0 7px 20px #cccccc',
    minHeight: '200px'
}))

export default function SuffixNewImportTask(props) {
    const location = useLocation();
    const path = location.pathname;
    const dispatch = useDispatch();


    const [loading, setLoading] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState({ open: false, msg: '', msgLv: ''});

    const { suffixBatches, batchRefresh } = useSelector(state => state.allBatches);


    useEffect(() => {
        // getActiveBatchProgress("ImportValueSet", setLoading, setSnackbarMsg)
        //     .then( res => {
        //         res && dispatch(addsuffixBatch(res));
        //     })
        dispatch(getAllBatches());
    }, [batchRefresh])

    return (
        <StyledContainer>
            <ExternalSourceBreadcrumbs path={path} />
            <h3 className='title'>
                New Suffix Import Task
            </h3>
            <Grid item xs={12} md={12} lg={12}>
                <h4>Prov Suffix ValueSet URL</h4>
                <StyledPaper sx={{minHeight: '120px'}}>
                    <Typography gutterBottom>
                        Please enter the URL:
                    </Typography>
                    <SuffixPagePasteURLPanel/>
                </StyledPaper>
            </Grid>
            <br/>
            <br/>
            <Grid item xs={12} md={12} lg={12}>
                <h4>Suffix Import Progress</h4>
                <StyledPaper>
                    {/*{ suffixStatus && <Alert severity={batchCurrentStatus[suffixStatus].getStatus} icon={false}>{batchCurrentStatus[suffixStatus].getMsg("suffix")}</Alert>}*/}
                    { suffixBatches.length > 0 && suffixBatches[0].status !== 'Init' &&
                        <Alert severity={batchCurrentStatus[suffixBatches[0].status].getStatus} icon={false}>{batchCurrentStatus[suffixBatches[0].status].getMsg("suffix")}</Alert>}
                    {/*{ suffixId && suffixStatus !== 'Completed' && suffixStatus !== 'Cancelled' && suffixStatus !== 'Failed' &&*/}
                    {/*    <suffixBatchProcessBar /> }*/}
                    { suffixBatches.length > 0 && suffixBatches[0].status !== 'Completed' && suffixBatches[0].status !== 'Cancelled' && suffixBatches[0].status !== 'Failed' &&
                        <ExternalSourceBatchProgressBar batch={suffixBatches[0]}/> }
                </StyledPaper>
            </Grid>
            {snackbarMsg.msg && snackbarMsg.msgLv &&
                <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            }

            <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}} open={ loading }>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </StyledContainer>
    )
}

